import Layout from '../../../components/Layout';
import { Paintbrush } from 'lucide-react';
import { Card, CardContent } from '../../../components/ui/Card';

export default function Design() {
  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Design</h1>
            <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">
              Design tools and utilities
            </p>
          </div>
        </div>

        {/* Holding Page Content */}
        <Card>
          <CardContent className="p-12">
            <div className="flex flex-col items-center justify-center text-center">
              <div className="mb-6 p-4 bg-gray-100 dark:bg-gray-700 rounded-full">
                <Paintbrush className="h-12 w-12 text-gray-400 dark:text-gray-500" />
              </div>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">
                Design Tools Coming Soon
              </h2>
              <p className="text-xs text-gray-600 dark:text-gray-400 max-w-md">
                This section will contain design tools and utilities to help with your business design needs.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
